// extracted by mini-css-extract-plugin
export default {"video_player":"_1xNfF","videoPlayer":"_1xNfF","video_container":"_2-kJw","videoContainer":"_2-kJw"};